import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { FormaPagoEditComponent } from '../forma-pago-edit/forma-pago-edit.component';

@Component({
  selector: 'app-forma-pago',
  templateUrl: './forma-pago.component.html',
  styleUrls: ['./forma-pago.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class FormaPagoComponent implements OnInit {
  errMsg:any;
  loading: boolean = false;
  forms:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<FormaPagoComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnInicio();
  }

  fnInicio(){
    this.loading = true;
    this.dataService.getFormas(1, 99).subscribe(
                      rows => {   
                              this.forms = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormasCargadas());
  }

  fnFormasCargadas(){
    //console.log(this.forms);
    this.loading = false;
  }

  fnEditar(form){
    //console.log("Editar: " + mon.idMon);
    let dialogRef = this.dialog.open(FormaPagoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:form.idForma,
                                            item:form
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");
                                    this.fnInicio();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(FormaPagoEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item:{ 'forma': null,
                                                   'descrip': null,
                                                   'gpo': '-',
                                                   'act': 1 }
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");
                                    this.fnInicio();
                                    }); 
  }

}



